export enum TypeContact {
  WHATSAPP = 0,
  EMAIL = 1,
}

export enum TypeUser {
  BASEUSER,
  COMPANY,
  USER,
  COLLABORATOR,
  ADM,
}

export enum Role {
  ASSISTANT,
  USER,
  SYSTEM,
}

export enum NotificationType {
  ALERT = 0,
  //NEW_SERVICE = 1,
  NEW_MESSAGE = 2,
  NEW_SOLICITATION = 3,
  NEW_DEMAND = 4,
  SENDED_NEW_DEMAND = 5,
  //NEW_ATTACHMENT = 6,
  //NEW_DATELIMIT = 7,
  //STATUS_CHANGE = 8,
  //PAYMENT_ALERT = 9,
  DEMAND_COUNTER_PROPOSAL = 10,
  SOLICITATION_CONCLUSION = 11,
  DEMAND_CANCEL = 12,
  REPORT_READY = 13,
}
export const labelNotification: { [key in keyof typeof NotificationType]?: string } = {
  [NotificationType.ALERT]: 'Alert',
  [NotificationType.NEW_MESSAGE]: 'Novas mensagens',
  //[NotificationType.NEW_SERVICE]: 'Novos serviços/oportunidades na sua região',
  [NotificationType.NEW_SOLICITATION]: 'Nova solicitação registrada',
  [NotificationType.NEW_DEMAND]: 'Nova demanda registrada',
  [NotificationType.SENDED_NEW_DEMAND]: 'Nova demanda enviada',
  // [NotificationType.NEW_ATTACHMENT]: 'Novo documento anexado',
  // [NotificationType.NEW_DATELIMIT]: 'Alteração de data limite',
  // [NotificationType.STATUS_CHANGE]: 'Alteração de status no serviço',
  // [NotificationType.PAYMENT_ALERT]: 'Alerta de prazo de pagamento',
  [NotificationType.DEMAND_COUNTER_PROPOSAL]: 'Notificação ao receber contra proposta',
  [NotificationType.SOLICITATION_CONCLUSION]: 'Notificação ao concluir uma solicitação',
  [NotificationType.DEMAND_CANCEL]:
    'Notificação em caso de cancelamento da demanda pelo correspondente',
  [NotificationType.REPORT_READY]: 'Relatório disponível para download',
};
export enum Receiver {
  HUB = 0,
  WHATSAPP = 1,
  EMAIL = 2,
}
export enum ProfileType {
  REQUESTER,
  APPROVER,
  OPERATOR,
  FINANCIAL,
}
export const labelProfileType = {
  [ProfileType.REQUESTER]: 'Solicitante',
  [ProfileType.APPROVER]: 'Aprovador',
  [ProfileType.OPERATOR]: 'Operador',
  [ProfileType.FINANCIAL]: 'Financeiro',
};
export type EnumDictionary<T extends string | symbol | number, U> = {
  [K in T]: U;
};

export enum ClassificationType {
  DIAMOND,
  GOLD,
  SILVER,
  BRONZE,
}
export enum AudienceType {
  CONCILIATION = 0,
  INITIAL = 1,
  UNA = 2,
  INSTRUCTION = 3,
  JUDGMENT = 4,
  OVERINDEBTEDNESS = 5,
  CREDITORS_GENERAL_ASSEMBLY = 6,
}
export const labelAudienceType = {
  [AudienceType.CONCILIATION]: 'Conciliação',
  [AudienceType.INITIAL]: 'Inicial',
  [AudienceType.UNA]: 'Una',
  [AudienceType.INSTRUCTION]: 'Instrução',
  [AudienceType.JUDGMENT]: 'Julgamento',
  [AudienceType.OVERINDEBTEDNESS]: 'Superendividamento',
  [AudienceType.CREDITORS_GENERAL_ASSEMBLY]: 'Assembleia Geral de Credores',
};

export const labelExternalContacts = {
  // [TypeContact.CELL]: 'Celular',
  [TypeContact.WHATSAPP]: 'WhatsApp',
  [TypeContact.EMAIL]: 'E-mail',
};
export enum UserProfileType {
  LAWYER,
  TRAINEE,
  OTHERS,
}
export const labelUserProfileType = {
  [UserProfileType.LAWYER]: 'Advogado',
  [UserProfileType.TRAINEE]: 'Estagiário',
  [UserProfileType.OTHERS]: 'Outros',
};

export enum ValidationType {
  OAB,
  RG,
  CPF,
}
export const labelValidationType = {
  [ValidationType.OAB]: 'OAB',
  [ValidationType.RG]: 'RG',
  [ValidationType.CPF]: 'CPF',
};

export enum FileUsageType {
  FRONT,
  BACK,
}
export const ItemType = {
  DEPARTMENT: 'department',
};

export enum TypeCardUser {
  SEND_REQUEST_CONTACT,
  ADD_CONTACT_CUSTOM_CONTACTS,
  FRIEND,
  REQUEST_SERVICE,
  MESSAGE_SERVICE,
  RESPOND_REQUEST_CONTACT,
}
export enum TypeCardUserSolicitation {
  REQUEST,
  REQUEST_SERVICE,
  MESSAGE_SERVICE,
  NONE,
}
export enum ServiceStatus {
  PENDING,
  IN_PROGRESS,
  IN_APPROVAL_REQUESTER,
  IN_APPROVAL_APPROVER,
  CONCLUED,
  CANCELED,
  UNPAID,
}
export enum SolicitationCancelationStatus {
  OTHER,
  REASSIGNED_AUDIENCE,
  AUDIENCE_CANCELED,
  HEARING_WITHDRAWN_FROM_THE_AGENDA,
  DAF_DOES_NOT_CONTRACT,
  OPEN_PROTOCOL_AS_DUE_DILIGENCE,
  OPENED_BY_MISTAKE,
  WRONGLY_REQUESTED,
  SOLICITATION_CAN_BE_MADE_ONLINE,
  WRONG_OPEN_PROTOCOL,
  CORRESPONDENT_DOES_NOT_SERVE_THE_LOCATION,
  DOES_NOT_ACCEPT_THE_TARGETED_OFFERED_VALUE,
  NOT_AVAILABLE_FOR_THE_ACT,
  DOES_NOT_ACCEPT_THE_TERMS_OF_PAYMENT_CONTRACT,
  UNDO_SOLICITATION,
}

export const labelSolicitationCancelationStatus = {
  [SolicitationCancelationStatus.OTHER]: 'Outro',
  [SolicitationCancelationStatus.REASSIGNED_AUDIENCE]: 'Audiência redesignada',
  [SolicitationCancelationStatus.AUDIENCE_CANCELED]: 'Audiência cancelada vara',
  [SolicitationCancelationStatus.HEARING_WITHDRAWN_FROM_THE_AGENDA]: 'Audiência retirada de pauta',
  [SolicitationCancelationStatus.DAF_DOES_NOT_CONTRACT]:
    'Protocólo aberto em SP - daf não realiza contratação',
  [SolicitationCancelationStatus.OPEN_PROTOCOL_AS_DUE_DILIGENCE]:
    'Protocólo aberto como diligência',
  [SolicitationCancelationStatus.OPENED_BY_MISTAKE]: 'Aberto por equívoco',
  [SolicitationCancelationStatus.WRONGLY_REQUESTED]: 'Solicitado de forma equivocada',
  [SolicitationCancelationStatus.SOLICITATION_CAN_BE_MADE_ONLINE]:
    'Solicitação pode ser realizada online',
  [SolicitationCancelationStatus.WRONG_OPEN_PROTOCOL]: 'Protocólo aberto errado',
  [SolicitationCancelationStatus.CORRESPONDENT_DOES_NOT_SERVE_THE_LOCATION]:
    'Correspondente não atende a localidade',
  [SolicitationCancelationStatus.DOES_NOT_ACCEPT_THE_TARGETED_OFFERED_VALUE]:
    'Não aceita o valor direcionado / ofertado',
  [SolicitationCancelationStatus.NOT_AVAILABLE_FOR_THE_ACT]:
    'Não possui disponibilidade para o ato',
  [SolicitationCancelationStatus.DOES_NOT_ACCEPT_THE_TERMS_OF_PAYMENT_CONTRACT]:
    'Não aceita as condições de pagamento / contrato',
  [SolicitationCancelationStatus.UNDO_SOLICITATION]: 'Solicitação desfeita',
};

export enum RefusalConclusionReason {
  OTHER,
  REASSIGNED_AUDIENCE,
  AUDIENCE_CANCELED,
  HEARING_WITHDRAWN_FROM_THE_AGENDA,
  DAF_DOES_NOT_CONTRACT,
  OPEN_PROTOCOL_AS_DUE_DILIGENCE,
  OPENED_BY_MISTAKE,
  WRONGLY_REQUESTED,
  SOLICITATION_CAN_BE_MADE_ONLINE,
  WRONG_OPEN_PROTOCOL,
  CORRESPONDENT_DOES_NOT_SERVE_THE_LOCATION,
  DOES_NOT_ACCEPT_THE_TARGETED_OFFERED_VALUE,
  NOT_AVAILABLE_FOR_THE_ACT,
  DOES_NOT_ACCEPT_THE_TERMS_OF_PAYMENT_CONTRACT,
  UNDO_SOLICITATION,
}

export enum RequestsSubmittedStatus {
  PENDING,
  ACCEPT,
  REFUSED,
  CANCELED,
}

export enum RefusalReason {
  OTHER,
  REASSIGNED_AUDIENCE,
  AUDIENCE_CANCELED,
  HEARING_WITHDRAWN_FROM_THE_AGENDA,
  DAF_DOES_NOT_CONTRACT,
  OPEN_PROTOCOL_AS_DUE_DILIGENCE,
  OPENED_BY_MISTAKE,
  WRONGLY_REQUESTED,
  SOLICITATION_CAN_BE_MADE_ONLINE,
  WRONG_OPEN_PROTOCOL,
  CORRESPONDENT_DOES_NOT_SERVE_THE_LOCATION,
  DOES_NOT_ACCEPT_THE_TARGETED_OFFERED_VALUE,
  NOT_AVAILABLE_FOR_THE_ACT,
  DOES_NOT_ACCEPT_THE_TERMS_OF_PAYMENT_CONTRACT,
  UNDO_SOLICITATION,
}
export enum SolucionareErrors {
  INVALID_TOKEN,
  INVALID_CODE_SEARCH,
  INVALID_NUMBER_PROCESS,
  INVALID_RELATIONAL_NAME,
  INVALID_CODE_SEARCH_RESULT,
  INVALID_CODE_SEARCH_STATUS,
  INVALID_CODE_SEARCH_RESULT_STATUS,
  INVALID_TOKEN_INVALID_RELATIONAL_NAME,
}
export enum PaymentSolicitationStatus {
  UNPAID,
  PAID,
}

export enum GetSolicitationFilterDateType {
  FROM_START,
  FROM_EXPIRATION,
}
export enum ExternalServiceType {
  SOLICITATION,
  DEMAND,
}

export enum BankAccountType {
  SAVINGS_ACCOUNT,
  CHECKING_ACCOUNT,
  SALARY_ACCOUNT,
  PAYMENT_ACCOUNT,
}
export const labelBankAccountType = {
  [BankAccountType.SAVINGS_ACCOUNT]: 'Conta Poupança',
  [BankAccountType.CHECKING_ACCOUNT]: 'Conta Corrente',
  [BankAccountType.SALARY_ACCOUNT]: 'Conta Salário',
  [BankAccountType.PAYMENT_ACCOUNT]: 'Conta Pagamento',
};

export enum PixType {
  PHONE,
  MAIL,
  CPF,
  CNPJ,
  RANDOM,
}

export enum MessageType {
  OTHER,
  TEXT,
  IMAGE,
  VIDEO,
  LINK,
  INFO,
  CONTACT,
  LOCATION,
  AUDIO,
}

export enum ContactStatus {
  BLOCKED,
  RELEASED,
  PENDING,
  REFUSED,
}

export enum ModalPaymentType {
  UPDATE_PAYMENT,
  FINALIZE_SOLICITATION,
}
export enum PostType {
  OTHER,
  TEXT,
  IMAGE,
  LOCATION,
}

export const labelPixType = {
  [PixType.PHONE]: 'Telefone',
  [PixType.MAIL]: 'E-mail',
  [PixType.CPF]: 'CPF',
  [PixType.CNPJ]: 'CNPJ',
  [PixType.RANDOM]: 'Aleatório',
};

export const labelPaymentStatus = {
  [PaymentSolicitationStatus.UNPAID]: 'Não Pago',
  [PaymentSolicitationStatus.PAID]: 'Pago',
};

export const labelServiceStatus = {
  [ServiceStatus.PENDING]: 'Pendente',
  [ServiceStatus.IN_PROGRESS]: 'Em andamento',
  [ServiceStatus.IN_APPROVAL_REQUESTER]: 'Aguardando aprovação do administrador',
  [ServiceStatus.IN_APPROVAL_APPROVER]: 'Aguardando aprovação do aprovador',
  [ServiceStatus.CONCLUED]: 'Concluído',
  [ServiceStatus.CANCELED]: 'Cancelado',
  [ServiceStatus.UNPAID]: 'Pagamento não realizado',
};

export enum CorrespondenceType {
  DILIGENCE = 0,
  AUDIENCE = 1,
  PROTOCOL = 2,
  CUSTOM = 3,
}
export const labelCorrespondenceType = {
  [CorrespondenceType.DILIGENCE]: 'Diligência',
  [CorrespondenceType.AUDIENCE]: 'Audiência',
  [CorrespondenceType.PROTOCOL]: 'Protocolo',
  [CorrespondenceType.CUSTOM]: 'Personalizado',
};

export enum AttachmentType {
  OTHER = 0,
  DELEGATION = 1,
  PROTOCOL = 2,
  AUTHORIZATION = 3,
  PETITION = 4,
  PREPOSITION_LETTER = 5,
  CONTESTATION = 6,
  DEFENSE = 7,
  GUIDE = 8,
  PROOF = 9,
  CONTRACT = 10,
  DELEGATION_OR_AUTHORIZATION = 11,
}
export enum HistoryType {
  OTHER = 0,
  NOTE = 1,
  ATTACHMENT = 2,
  CHAT = 3,
  PROPOSAL_CHAT = 4,
  NEW_DATELIMIT = 5,
  CHANGE_STATUS = 6,
  PAYMENT = 7,
  SEND_PROPOSAL = 8,
  ACCEPT_PROPOSAL = 9,
  REFUSE_PROPOSAL = 10,
  UNDO_PROPOSAL = 11,
  SEND_ADDITIONAL_VALUE = 12,
  ACCEPT_ADDITIONAL_VALUE = 13,
  REFUSE_ADDITIONAL_VALUE = 14,
  CREATE_SOLICITATION = 15,
  REFUSE_CONCLUSION = 16,
  UPDATE_SOLICITATION_VALUE = 17,
  CANCEL_DEMAND = 18,
  UPDATE_SOLICITATION = 19,
}
export const labelHistoryType = {
  [HistoryType.OTHER]: 'Outro',
  [HistoryType.NOTE]: 'Anotação',
  [HistoryType.ATTACHMENT]: 'Anexo',
  [HistoryType.CHAT]: 'Mensagem',
  [HistoryType.PROPOSAL_CHAT]: 'Mensagem',
  [HistoryType.NEW_DATELIMIT]: 'Nova data limite',
  [HistoryType.CHANGE_STATUS]: 'Alteração de status',
  [HistoryType.PAYMENT]: 'Pagamento',
  [HistoryType.SEND_PROPOSAL]: 'Proposta enviada',
  [HistoryType.ACCEPT_PROPOSAL]: 'Proposta aceita',
  [HistoryType.REFUSE_PROPOSAL]: 'Proposta recusada',
  [HistoryType.UNDO_PROPOSAL]: 'Proposta desfeita',
  [HistoryType.SEND_ADDITIONAL_VALUE]: 'Valor adicional enviado',
  [HistoryType.ACCEPT_ADDITIONAL_VALUE]: 'Valor adicional aceito',
  [HistoryType.REFUSE_ADDITIONAL_VALUE]: 'Valor adicional recusado',
  [HistoryType.CREATE_SOLICITATION]: 'Solicitação criada',
  [HistoryType.REFUSE_CONCLUSION]: 'Conclusão recusada',
  [HistoryType.UPDATE_SOLICITATION_VALUE]: 'Valor da solicitação atualizado',
  [HistoryType.CANCEL_DEMAND]: 'Demanda cancelada',
  [HistoryType.UPDATE_SOLICITATION]: 'Solicitação editada',
};

export const labelRefusalReason = {
  [RefusalReason.OTHER]: 'Outro',
  [RefusalReason.REASSIGNED_AUDIENCE]: 'Audiência redesignada',
  [RefusalReason.AUDIENCE_CANCELED]: 'Audiência cancelada vara',
  [RefusalReason.HEARING_WITHDRAWN_FROM_THE_AGENDA]: 'Audiência retirada de pauta',
  [RefusalReason.DAF_DOES_NOT_CONTRACT]: 'Protocólo aberto em SP - daf não realiza contratação',
  [RefusalReason.OPEN_PROTOCOL_AS_DUE_DILIGENCE]: 'Protocólo aberto como diligência',
  [RefusalReason.OPENED_BY_MISTAKE]: 'Aberto por equívoco',
  [RefusalReason.WRONGLY_REQUESTED]: 'Solicitado de forma equivocada',
  [RefusalReason.SOLICITATION_CAN_BE_MADE_ONLINE]: 'Solicitação pode ser realizada online',
  [RefusalReason.WRONG_OPEN_PROTOCOL]: 'Protocólo aberto errado',
  [RefusalReason.CORRESPONDENT_DOES_NOT_SERVE_THE_LOCATION]:
    'Correspondente não atende a localidade',
  [RefusalReason.DOES_NOT_ACCEPT_THE_TARGETED_OFFERED_VALUE]:
    'Não aceita o valor direcionado / ofertado',
  [RefusalReason.NOT_AVAILABLE_FOR_THE_ACT]: 'Não possui disponibilidade para o ato',
  [RefusalReason.DOES_NOT_ACCEPT_THE_TERMS_OF_PAYMENT_CONTRACT]:
    'Não aceita as condições de pagamento / contrato',
  [RefusalReason.UNDO_SOLICITATION]: 'Solicitação desfeita',
};

export const labelRefusalConclusionReason = {
  [RefusalConclusionReason.OTHER]: 'Outro',
  [RefusalConclusionReason.REASSIGNED_AUDIENCE]: 'Audiência redesignada',
  [RefusalConclusionReason.AUDIENCE_CANCELED]: 'Audiência cancelada na vara',
  [RefusalConclusionReason.HEARING_WITHDRAWN_FROM_THE_AGENDA]: 'Audiência retirada de pauta',
  [RefusalConclusionReason.DAF_DOES_NOT_CONTRACT]:
    'Protocólo aberto em SP - daf não realiza contratação',
  [RefusalConclusionReason.OPEN_PROTOCOL_AS_DUE_DILIGENCE]: 'Protocólo aberto como diligência',
  [RefusalConclusionReason.OPENED_BY_MISTAKE]: 'Aberto por equívoco',
  [RefusalConclusionReason.WRONGLY_REQUESTED]: 'Solicitado de forma equivocada',
  [RefusalConclusionReason.SOLICITATION_CAN_BE_MADE_ONLINE]:
    'Solicitação pode ser realizada online',
  [RefusalConclusionReason.WRONG_OPEN_PROTOCOL]: 'Protocólo aberto errado',
  [RefusalConclusionReason.CORRESPONDENT_DOES_NOT_SERVE_THE_LOCATION]:
    'Correspondente não atende a localidade',
  [RefusalConclusionReason.DOES_NOT_ACCEPT_THE_TARGETED_OFFERED_VALUE]:
    'Não aceita o valor direcionado / ofertado',
  [RefusalConclusionReason.NOT_AVAILABLE_FOR_THE_ACT]: 'Não possui disponibilidade para o ato',
  [RefusalConclusionReason.DOES_NOT_ACCEPT_THE_TERMS_OF_PAYMENT_CONTRACT]:
    'Não aceita as condições de pagamento / contrato',
  [RefusalConclusionReason.UNDO_SOLICITATION]: 'Solicitação desfeita',
};

export enum ImportType {
  COLLABORATOR,
  CLIENT,
  BRANCH,
  DEPARTMENT,
  FINANCIAL,
}
export enum StatusSearch {
  AGUARDANDO,
  CONCLUIDO,
}

export enum StepActionType {
  CLICK = 'click',
  NEXT = 'next',
}

export enum RegistrationOrigin {
  OTHER,
  INSTAGRAM,
  FACEBOOK,
  LINKEDIN,
  EMAIL,
  INDICATION,
}
export enum TutorialType {
  FEED_MY_SERVICES = 0,
  FINANCIAL_REPORT = 1,
  COMPLEMENT_REGISTER = 2,
  BRANCH_OFFICE = 3,
  CLIENT = 4,
  COLLABORATOR = 5,
  COURT = 6,
  DEPARTMENT = 7,
  LEGAL_PERSON_ACCOUNT = 8,
  LOGIN = 9,
  MY_VALUES = 10,
  NATURAL_PERSON_ACCOUNT = 11,
  PASSWORD_RECOVERY = 12,
  PROFILES = 13,
  REGISTER = 14,
  SOLICITATION = 15,
  USER_NOTIFICATION = 16,
  WALLET = 17,
  YOUR_DEMANDS = 18,
  YOUR_SOLICITATIONS = 19,
  REACTIVATE_ACCOUNT = 20,
}
export enum PlanStatus {
  ACTIVE = 0,
  INACTIVE = 1,
  EXPIRED = 2,
}

export enum BillingCycle {
  MONTHLY = 0,
  ANNUAL = 1,

}


export const labelBillingCycle = {
  [BillingCycle.MONTHLY]: 'Mensal',
  [BillingCycle.ANNUAL]: 'Anual',
};